module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bdinfo"
  }, [_c('a-layout', {
    staticStyle: {
      "min-height": "100vh"
    },
    attrs: {
      "id": "components-layout-demo-side"
    }
  }, [_c('menuBar', {
    attrs: {
      "current": _vm.current,
      "openKeys": _vm.openKeys
    }
  }), _vm._v(" "), _c('a-layout', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('topBar'), _vm._v(" "), _c('a-layout-content', {
    staticStyle: {
      "margin": "16px",
      "min-width": "1192px"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "line-height": "30px",
      "margin-bottom": "10px",
      "font-weight": "700",
      "padding-left": "8px"
    }
  }, [_vm._v("查看店主")]), _vm._v(" "), _c('div', {
    staticClass: "contentcard",
    staticStyle: {
      "margin-bottom": "0px",
      "padding-bottom": "70px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flow-root",
      "position": "relative"
    }
  }, [_c('a-input-search', {
    staticStyle: {
      "width": "200px",
      "float": "right",
      "margin": "-10px 0 10px 0"
    },
    attrs: {
      "placeholder": "搜索店主"
    },
    on: {
      "search": _vm.onSearchShopkeeper
    }
  })], 1), _vm._v(" "), _c('a-row', {
    staticStyle: {
      "background-color": "#f3f3f5",
      "font-size": "14px",
      "height": "60px",
      "font-weight": "700"
    },
    attrs: {
      "type": "flex",
      "justify": "space-around",
      "align": "middle"
    }
  }, [_c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 4
    }
  }, [_vm._v("店铺名称")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 3
    }
  }, [_vm._v("联系电话")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("店铺地址")]), _vm._v(" "), _c('a-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 6
    }
  }, [_vm._v("操作")])], 1), _vm._v(" "), (_vm.issearch) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "border-radius": "4px",
      "padding": "11px 0 0 0"
    }
  }, [_c('a-spin')], 1) : _vm._e(), _vm._v(" "), ((!_vm.shopkeeperlist.length) && (!_vm.issearch)) ? _c('div', [_c('a-alert', {
    attrs: {
      "message": "查询结果为空",
      "banner": "",
      "type": "info"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm._l((_vm.shopkeeperlist), function(shopkeeper, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "color": "#666",
        "font-size": "14px"
      }
    }, [_c('a-row', {
      staticStyle: {
        "border": "#e8e8e8 solid 1px",
        "border-top": "none",
        "min-height": "60px",
        "padding": "5px 0"
      },
      attrs: {
        "type": "flex",
        "justify": "space-around",
        "align": "middle"
      }
    }, [(shopkeeper.UIC_User_Licenses.length > 0) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v(_vm._s(shopkeeper.UIC_User_Licenses[0].name))]) : _vm._e(), _vm._v(" "), (shopkeeper.UIC_User_Licenses.length > 0) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v(_vm._s(shopkeeper.phone_number))]) : _vm._e(), _vm._v(" "), (shopkeeper.UIC_User_Licenses.length > 0) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 6
      }
    }, [_vm._v(_vm._s(shopkeeper.UIC_User_Licenses[0].province + shopkeeper.UIC_User_Licenses[0].city + shopkeeper.UIC_User_Licenses[0].district + shopkeeper.UIC_User_Licenses[0].street))]) : _vm._e(), _vm._v(" "), (shopkeeper.UIC_User_Licenses.length == 0) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 4
      }
    }, [_vm._v("该店主暂未上传营业执照,请联系店主尽快上传")]) : _vm._e(), _vm._v(" "), (shopkeeper.UIC_User_Licenses.length == 0) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 3
      }
    }, [_vm._v(_vm._s(shopkeeper.phone_number))]) : _vm._e(), _vm._v(" "), (shopkeeper.UIC_User_Licenses.length == 0) ? _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 6
      }
    }, [_vm._v("暂无")]) : _vm._e(), _vm._v(" "), _c('a-col', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "span": 6
      }
    }, [_c('a-button-group', [_c('a-button', {
      attrs: {
        "size": "small",
        "type": "link",
        "disabled": shopkeeper.UIC_User_Licenses.length == 0
      },
      on: {
        "click": function($event) {
          return _vm.lookphoto(shopkeeper.UIC_User_Licenses[0])
        }
      }
    }, [_vm._v("查看营业执照")]), _vm._v("|\n\t\t\t\t\t\t\t\t      "), _c('a-button', {
      attrs: {
        "size": "small",
        "type": "link"
      },
      on: {
        "click": function($event) {
          return _vm.gototrade(shopkeeper)
        }
      }
    }, [_vm._v("查看订单")]), _vm._v("|\n\t\t\t\t\t\t\t\t\t  "), _c('a-button', {
      attrs: {
        "size": "small",
        "type": "link",
        "disabled": ""
      }
    }, [_vm._v("删除")])], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "position": "relative",
      "bottom": "-18px"
    }
  }, [_c('a-pagination', {
    attrs: {
      "showSizeChanger": "",
      "current": _vm.endpage / _vm.pageSize,
      "pageSize": _vm.pageSize,
      "total": _vm.shopkeepersum,
      "showQuickJumper": ""
    },
    on: {
      "showSizeChange": _vm.onShowSizeChange,
      "change": _vm.pageChange
    }
  })], 1)], 2)]), _vm._v(" "), _c('bottomBar')], 1)], 1), _vm._v(" "), _c('div', [_c('a-back-top')], 1), _vm._v(" "), _c('a-modal', {
    attrs: {
      "title": "营业执照",
      "visible": _vm.photo_visible,
      "width": 1200,
      "footer": null
    },
    on: {
      "cancel": _vm.photo_Cancel
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.photo_info,
      "height": "500px"
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05809468","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/client/components/view/bdmanagement/bdinfo/index.vue
// module id = 2361
// module chunks = 1